import { makeStyles } from "@material-ui/core";

export const stepperStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  iconStepper: {
    fill: "white"
  },
  stepper: {
    "& .MuiStepIcon-active": {
      color: '#372d2d'
      //display: "none"
    },
    "& .MuiStepLabel-label": {
      //fontFamily: 'MyriadPro-Bold'
    },
  },
}))

export const buttonsApp = makeStyles(theme => ({
  textField: {
    width: 200,
  },
  margin: {
    margin: theme.spacing(1),
  },
  buttonBack: {
    color: 'white',
    backgroundColor: '#a7a8a8',
    "&:hover": {
      color: 'white',
      backgroundColor: '#a7a8a8',
    },
  },
  buttonOk: {
    color: 'white',
    backgroundColor: '#2E2757',
    "&:hover": {
      color: 'white',
      backgroundColor: '#2E2757',
    },
  },
  buttonStandard: {
    fontSize: '1rem',
    color: '#ffffff',
    borderRadius: '4px',
    '&.Mui-disabled': {
        backgroundColor: "#a7a8a8",
    },
    '&:hover': {
        backgroundColor: "#706D85",
    },
    backgroundColor: "#2E2757",
    //fontFamily: 'MyriadPro-Bold',
},

}));